import { UnableToDeserializePublicKeyError, UnableToSerializePublicKeyError, } from '../../../../errors/errors.js';
import moneroKeys from './monero-public-key.js';
import publicKeys from './public-key.js';
import xpub from './xpub.js';
const validateSerialized = (publicKey) => {
    return publicKeys.validateSerialized(publicKey) || moneroKeys.validateSerialized(publicKey);
};
const serialize = (publicKey) => {
    if (Buffer.isBuffer(publicKey)) {
        return publicKeys.serialize(publicKey);
    }
    if (typeof publicKey === 'object') {
        return moneroKeys.serialize(publicKey);
    }
    throw new UnableToSerializePublicKeyError();
};
const deserialize = (publicKey) => {
    if (publicKeys.validateSerialized(publicKey)) {
        return publicKeys.deserialize(publicKey);
    }
    if (moneroKeys.validateSerialized(publicKey)) {
        return moneroKeys.deserialize(publicKey);
    }
    throw new UnableToDeserializePublicKeyError();
};
const serialization = { publicKey: { validateSerialized, serialize, deserialize }, xpub };
export { serialization as default };
